<script>
  import GroupAjax from '@ajax/group';
  import ShareModal from '@app-components/modal/ShareModal.svelte';
  import ListCommentsDesktop from '@app-components/comments/ListCommentsDesktop.svelte';
  import ListSearchModal from '@app-components/modal/ListSearchModal.svelte';
  import BookmarkButton from '@app-components/BookmarkButton.svelte';
  import ListCopier from '@app-components/group/ListCopier.svelte';
  import ShareIcon from '@app-components/group/ShareIcon.svelte';
  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import FloatingLikeOrComment from '@app-components/group/FloatingLikeOrComment.svelte';

  import queryString from 'query-string';
  import { getCurrentUserStore } from '@stores/current_user';
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';
  import Track from '@utils/track';

  export let groupStore;
  export let group;
  export let loaded;
  export let recs;
  export let mobile;
  export let commentId = null;
  export let showCommentsModal = commentId != null;
  export let displayStyle;
  export let showFloatingLikeOrComment = false;
  export let spotlightUser;

  let currentUser = getCurrentUserStore('default');

  const minimumRecCount = 5;
  let likesCount = 0;
  let likedByUser = false;
  let showCreateAccountModal = false;
  let likeInProgress = false;

  $: commentsCount = (group && group.comments && group.comments.total) || 0;
  $: likesCount = (group && group.likes && group.likes.total) || 0;
  $: likedByUser = (group && group.likes && group.likes.current_user_liked) || false;
  $: owner = group && group.users.filter((u) => u.role == 'admin')[0];

  let queryParams;
  let showShareModal;
  let showSearchModal = false;

  let toggleBookmark;
  let bookmark;
  let trackBookmarkAction = function () {
    Track.spotlightListBookmarked({
      currentUser: currentUser,
      user: spotlightUser,
      groupBase: group,
      path: location.pathname,
    });
  };

  let toggleLike = async function () {
    if (!currentUser || !currentUser.id) {
      showCreateAccountModal = true;
      return;
    }

    if (likeInProgress) {
      return;
    }

    likeInProgress = true;

    if (likedByUser) {
      likesCount = likesCount - 1;
    } else {
      likesCount = likesCount + 1;
    }

    likedByUser = !likedByUser;
    await GroupAjax.like(group, {});

    if (groupStore) {
      groupStore.set(await GroupAjax.get(group.id));
    }
    if (likedByUser) {
      Track.spotlightListLiked({
        currentUser: currentUser,
        user: spotlightUser,
        groupBase: group,
        path: location.pathname,
      });
    }

    likeInProgress = false;
  };

  const trackListCommentClicked = function (){
    Track.spotlightListCommentClicked({
        currentUser: currentUser,
        user: spotlightUser,
        groupBase: group,
        path: location.pathname,
      });
  }

  onMount(() => {
    queryParams = queryString.parse(location.search) || {};
    commentId = queryParams['comment_id'] || queryParams['commentId'];
    showCommentsModal = queryParams['open-comments'] == 'true' || (!queryParams['detail_id'] && commentId != null);
    showShareModal = queryParams['open-share-with-members'] == 'true';

    if (queryParams && queryParams['open-comments'] == 'true') {
      window.history.replaceState(null, null, location.href.replace('?open-comments=true', ''));
    }
  });
</script>

<style style="text/scss" lang="scss" global>
  /* NOTE: this component uses global styles so that child components can access them too,
     but it is scoped using classes ("group-page-container-desktop") so the styles don't
     leak across the app. */

  .pinned-list-action-container.desktop {
    .regular-btn {
      &:hover {
        background: #ececec;
      }
    }
  }
  .pinned-list-action-container {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    gap: 12px;
    position: relative;

    .action-group {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
    }

    .clap-btn {
      .emoji {
        width: 21px;
        height: 21px;
        flex-shrink: 0;
        margin-top: -2px;
        display: inline-block;
        background: url(/images/icon__clapping.png) 50% no-repeat;
        background-size: cover;
        transition: all 0.2s ease-in-out;
      }

      :global(.emoji-active) {
        opacity: 0.2;
      }

      .claps-counter {
        margin-left: 12px;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .regular-btn {
      transition: 0.1s all;
      margin-left: 0px;
      border-radius: 8px;
      line-height: 10px;
      font-size: 14px;
      font-weight: 500;
      background: white;
      color: black;
      border: none;
      outline: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 8px;
      margin-bottom: 0px;
      svg {
        width: 20px;
        height: 20px;
      }
    }

    .comments-btn {
      .comments-counter {
        margin-left: 8px;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .action-group {
      gap: 6px;
      margin-left: -8px;
    }
  }
</style>

{#if showCreateAccountModal}
  <CreateAccountModal
    msgStyle="font-size: 20px;"
    eventDetails={{ trigger_event: 'like_button', group_base_id: group?.id, spotlight: true}}
    mobile={mobile}
    successCallback={() => {
      showCreateAccountModal = false;
      toggleLike();
    }}
    beforeDataSend={(data) => {
      data['sign_up_source'] = {
        source: 'list-like',
        group_base_id: group && group.id,
      };

      return data;
    }}
    showPassword={true}
    saveButtonFlow={true}
    buttonText="Create account"
    bind:showModal={showCreateAccountModal} />
{/if}

{#if showCommentsModal && !mobile}
  <ListCommentsDesktop customGroupStore={groupStore} bind:showModal={showCommentsModal} bind:commentId={commentId} />
{/if}

{#if showShareModal}
  <ShareModal bind:showShareModal={showShareModal} group={group} mobile={mobile} />
{/if}
{#if showSearchModal}
  <ListSearchModal group={group} bind:showModal={showSearchModal} mobile={mobile} />
{/if}

<div
  class:modal-mode={showCommentsModal}
  class="pinned-list-action-container {displayStyle} {mobile ? 'mobile' : 'desktop'} {currentUser && currentUser.id
    ? 'logged-in'
    : 'logged-out'}">
  <div class="action-group">
    {#if group.show_likes}
      <button class="comments-btn regular-btn" on:click|preventDefault|stopPropagation={toggleLike}>
        {#if likedByUser}
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
            <path
              d="M12.715 2C11.8913 2.00179 11.0866 2.2535 10.403 2.72324C9.71939 3.19299 9.18759 3.85961 8.875 4.63863C8.56207 3.85875 8.02944 3.19154 7.34478 2.72173C6.66011 2.25192 5.85429 2.00071 5.02967 2C2.73633 2 0.875 4.33879 0.875 6.68847C0.875 11.824 7.80833 16 8.875 16C9.94167 16 16.875 11.824 16.875 6.68847C16.875 4.33879 15.0137 2 12.715 2Z"
              fill="#FF5567"
              stroke="#FF5567"
              stroke-width="1.2" />
          </svg>
        {:else}
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
            <path
              d="M13.34 2C12.5163 2.00179 11.7116 2.2535 11.028 2.72324C10.3444 3.19299 9.81259 3.85961 9.5 4.63863C9.18707 3.85875 8.65444 3.19154 7.96978 2.72173C7.28511 2.25192 6.47929 2.00071 5.65467 2C3.36133 2 1.5 4.33879 1.5 6.68847C1.5 11.824 8.43333 16 9.5 16C10.5667 16 17.5 11.824 17.5 6.68847C17.5 4.33879 15.6387 2 13.34 2Z"
              stroke="black"
              stroke-width="1.2" />
          </svg>{/if}
        {#if likesCount > 0}
          <span class="comments-counter">{likesCount}</span>
        {/if}
      </button>
    {/if}

    {#if group.show_comments}
      <button
        class="comments-btn regular-btn"
        on:click|preventDefault|stopPropagation={() => {
          trackListCommentClicked();
          if (displayStyle == 'tile') {
            goto(`${group.path}?open-comments=true`);
          } else {
            showCommentsModal = !showCommentsModal;
          }
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
          <path
            d="M9.5 1C5.084 1 1.5 4.20129 1.5 8.20291C1.51196 9.165 1.72668 10.1137 2.13012 10.9872C2.53357 11.8606 3.11667 12.639 3.84133 13.2716L3.63333 16.5583C3.62961 16.6358 3.64736 16.7129 3.68462 16.7809C3.72188 16.849 3.77721 16.9055 3.8445 16.9441C3.91179 16.9827 3.98843 17.002 4.06598 16.9998C4.14353 16.9977 4.21898 16.9741 4.284 16.9318L7.084 15.0644C7.86961 15.2897 8.68273 15.4047 9.5 15.4058C13.916 15.4058 17.5 12.2045 17.5 8.20291C17.5 4.20129 13.916 1 9.5 1Z"
            stroke="black"
            stroke-width="1.2" />
        </svg>
        {#if commentsCount > 0}
          <span class="comments-counter">{commentsCount}</span>
        {/if}
      </button>
    {/if}
  </div>
  <div class="action-group action-group-second">
    {#if displayStyle != 'tile'}
      {#if group.permissions && group.permissions.edit}
        <button
          class="share-btn regular-btn"
          on:click={() => {
            showShareModal = true;
          }}>
          <ShareIcon />
        </button>
      {:else}
        <ListCopier group={group} mobile={mobile} relatedUserId={owner?.id}>
          <button class="share-btn regular-btn">
            <ShareIcon />
          </button>
        </ListCopier>
      {/if}
    {/if}
    <button class="bookmark-button regular-btn" on:click|preventDefault|stopPropagation={toggleBookmark}>
      <BookmarkButton
        bind:bookmark={bookmark}
        bind:toggleBookmark={toggleBookmark}
        on:bookmark-acted-upon={trackBookmarkAction}
        group={group}
        viewStyle="group"
        mobile={mobile} />
    </button>

    {#if !mobile && loaded && recs.length > minimumRecCount}
      <button
        class="search-btn regular-btn"
        on:click={() => {
          showSearchModal = true;
        }}>
        <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.7646 13.4854L15.2793 16M7.5293 15C11.2572 15 14.2793 11.9779 14.2793 8.25C14.2793 4.52208 11.2572 1.5 7.5293 1.5C3.80137 1.5 0.779297 4.52208 0.779297 8.25C0.779297 11.9779 3.80137 15 7.5293 15Z"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    {/if}
  </div>

  {#if showFloatingLikeOrComment && currentUser}
    <FloatingLikeOrComment group={group} mobile={mobile} />
  {/if}
</div>
